  <wms-dialog-header
    (onClose)="closeModal()"
    [title]="githubAppsAuth ? locale.TITLE_GITHUB_APPS_AUTHORIZATION_REQUIRED : locale.LABEL_UPDATE_VCS_CREDENTIALS">
  </wms-dialog-header>
  <wms-dialog-body>
    <ng-container *ngIf="githubAppsAuth">
      <div class="github-apps-auth">
        <div class="github-apps-auth__icon-wrap" title="{{ locale.LABEL_VCS_CREDENTIALS }}">
          <img [src]="getVcsIcon()" alt="" />
        </div>
        <p class="github-apps-auth__lead">{{ locale.MESSAGE_GITHUB_APPS_AUTH_DESCRIPTION }}</p>
      </div>
    </ng-container>
    <div class="repo-warning" *ngIf="!githubAppsAuth">
      <form #vcsUserCredForm="ngForm" class="wm-form">
        <wms-message [scopeDataset]="message" hideclose="true"></wms-message>
        <p class="vcs-label app-label" *ngIf="!message">{{ locale.LABEL_USER_VCS_CREDENTIALS_MSG }}</p>
        <div class="form-group app-composite-widget clearfix">
          <ul class="col-md-12 vcs-info">
            <li class="vcs-provider col-md-4">
              <div class="vcs-provider-details">
                <img [src]="getVcsIcon()"/>
              </div>
            </li>
            <li class="vcs-provider col-md-4">
              <div class="vcs-provider-details">
                <p class="vcs-label">{{ locale.LABEL_BASE_URL }}</p>
                <p class="vcs-value" title="{{vcsInfo.baseUrl}}">{{ vcsInfo.baseUrl }}</p>
              </div>
            </li>
            <li class="vcs-provider col-md-4">
              <div class="vcs-provider-details">
                <p class="vcs-label">{{ groupLabel }}</p>
                <p class="vcs-value" title="{{getGroupName()}}">{{ getGroupName() }}</p>
              </div>
            </li>
          </ul>
        </div>
        <p class="vcs-label app-label required">{{ locale.LABEL_USER_NAME }}:</p>
        <div class="form-group app-composite-widget clearfix">
          <div>
            <input type="text" class="form-control app-textbox" name="vcsUsername" autocomplete="off" autofocus
                   [(ngModel)]="vcsInfo.username" #vcsUsername="ngModel"
                   [ngClass]="{'required': vcsUsername.errors?.['required'] && !vcsUsername.pristine}" required/>
          </div>
        </div>
        <p
          class="vcs-label app-label required">{{ vcsInfo.vcsAccountType === 'BITBUCKET' ? locale.LABEL_PASSWORD : locale.LABEL_GIT_ACCESS_TOKEN }}
          :</p>
        <div class="form-group app-composite-widget clearfix">
          <div>
            <input type="password" class="form-control app-textbox" name="vcsAccessToken" autocomplete="off"
                   [(ngModel)]="vcsInfo.accessToken" #vcsAccessToken="ngModel"
                   [ngClass]="{'required': vcsAccessToken.errors?.['required'] && !vcsAccessToken.pristine}" required/>
          </div>
        </div>
        <a *ngIf="vcsInfo.vcsAccountType != 'BITBUCKET'" class="vcs-link" href="{{accessTokenLink}}"
           target="_blank">{{ locale.LABEL_ACCESS_TOKEN_HELP_TEXT }}</a>
      </form>
    </div>
  </wms-dialog-body>
  <wms-dialog-footer>
    <ng-container *ngIf="githubAppsAuth">
      <button name="wm-github-apps-not-now" class="btn button-secondary" (click)="closeModal()">{{ locale.LABEL_GITHUB_APPS_NOT_NOW }}</button>
      <button name="wm-github-apps-authorize" class="btn button-primary" (click)="authorizeGithubApps()">{{ locale.LABEL_AUTHORIZE_GITHUB }}</button>
    </ng-container>
    <ng-container *ngIf="!githubAppsAuth">
      <button name="wm-user-vcs-cancel" class="btn button-secondary" (click)="closeModal()">{{locale.LABEL_CANCEL}}</button>
      <button [disabled]="!vcsInfo.username || !vcsInfo.accessToken" name="wm-user-vcs-save" (click)="updateUserVCSCredentials()" class="btn button-primary" >{{locale.LABEL_SAVE}}</button>
    </ng-container>
  </wms-dialog-footer>
